<template>
  <v-container
    v-if='loaded'
    fill-height
    fluid
    grid-list-xl>
    <v-layout wrap>

      <v-dialog v-model="openAuditTrail" max-width="1400px">
        <app-audit-trail-timeline :entity="auditTrailEntityName" v-if='openAuditTrail' :entity_id="auditTrailEntityId" :fields='config_log.fields' :hide-fields="{ account: config_account.hideAuditFields }"/>
      </v-dialog>

      <v-flex sm12 xs12 md12 lg6>
        <core-field
          type='autocomplete'
          @input='updateProtocol'
          :field="protocolField"
        />
      </v-flex>
      <v-flex sm12 xs12 md12 lg6>
        <core-field
          type='autocomplete'
          @input='updateSite'
          :field="siteField"
        />
      </v-flex>
      <v-flex
        sm6
        xs12
        md6
        lg4>

        <material-stats-card
          color="primary"
          icon="mdi-store"
          title="Expiring drugs"
          :value="String(dashboardData.expiring.length)"
          :sub-text="`${expiring} pieces`"
        />
      </v-flex>

      <v-flex
        sm6
        xs12
        md6
        lg4>
        <material-stats-card
          color="orange"
          icon="mdi-book-alphabet"
          title="Available drugs"
          :value="String(dashboardData.available_drugs.length)"
          sub-icon="mdi-view-list"
          sub-text-color="float-right"
          :sub-text="`${available} pieces`"
        />
      </v-flex>

      <v-flex
        sm6
        xs12
        md6
        lg4>
        <material-stats-card
          color="info"
          icon="mdi-account"
          title="On site drugs"
          :value="String(dashboardData.centers_available_drugs.length)"
          sub-icon="mdi-view-list"
          :sub-text="`${center_available} pieces`"
        />
      </v-flex>

      <v-flex
        md12
        lg12>
          <!-- LOGS -->
        <app-table title='Global Audit Trail' hide-audit hide-create :config="config_log" @audit="openAudit"/>

      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import config_log from './config_log.js'
import config_account from '../account/config_index.js'
import { getList as getLogList, getDashboardData } from '@/api/log'
import user from '../../store/modules/user'
import app from '../../store/modules/app'

export default {
  data () {
    return {
      logs: [],
      protocol: '',
      site: '',
      totalLogs: 0,
      openAuditTrail: false,
      auditTrailEntityName: '',
      auditTrailEntityId: '',
      protocolField: {
        full: true,
        value: 'protocol_id',
        text: 'Protocol',
        type: 'autocomplete',
        title: 'name'
      },
      siteField: {
        full: true,
        value: 'site_id',
        text: 'Site',
        type: 'autocomplete',
        title: 'name'
      },
      dashboardData: {
      },
      filtersLogs: {
        http_verb: '!=GET'
      },
      pagination: { sortBy: 'insert_at', descending: true, itemsPerPage: 5 },
      loaded: false,
      config_log,
      config_account,
      headersLogs: [
        {
          sortable: false,
          text: 'Insert at',
          value: 'insert_at'
        },
        {
          sortable: false,
          text: 'Account',
          value: 'user'
        },
        {
          sortable: false,
          text: 'Route',
          value: 'route',
          align: 'right'
        },
        {
          sortable: false,
          text: 'Http method',
          value: 'http_verb',
          align: 'right'
        }
      ]
    }
  },
  computed: {
    expiring () {
      if (!this.dashboardData.expiring) return
      return this.dashboardData.expiring.reduce((tot, item) => tot += Number(item.tot), 0)
    },
    available () {
      if (!this.dashboardData.available_drugs) return
      return this.dashboardData.available_drugs.reduce((tot, item) => tot += Number(item.tot), 0)
    },
    center_available () {
      if (!this.dashboardData.centers_available_drugs) return
      return this.dashboardData.centers_available_drugs.reduce((tot, item) => tot += Number(item.tot), 0)
    }
  },
  beforeRouteEnter (to, from, next) {
    if (app.maintainance) return next({ path: '/maintainance' })
    else if (user.state.role === 'Administrator' || user.state.role === 'EMN User') next()
    else if (user.state.role === 'Site') next({ path: '/siterequest' })
    else if (user.state.role === 'EMN Estimates') next({ path: '/estimates' })
    else if (user.state.role === 'Monitor') next({ path: '/siterequest' })
    else next({ path: '/login' })
  },
  async mounted () {
    this.getLogs()
    this.getDashboardData()
  },
  methods: {
    openAudit (item) {
      const entityMap = {
        returned_has_drug: 'returned',
        fullyused_has_drug: 'fullyused',
        siteresponse_has_drug: 'siterequest',
        siterequest_has_drug: 'siterequest',
        patch_has_drug: 'patch',
        disposed_has_drug: 'disposed',
        request_has_drug: 'request',
        response_has_drug: 'request'        
      }

      const entity = entityMap[item.entity] ?? item.entity
      const entity_id = item?.response?.data && item?.response?.data[`${entity}_id`] ? item?.response?.data[`${entity}_id`] : item.entity_id

      this.auditTrailEntityName = entity
      this.auditTrailEntityId = entity_id
      this.openAuditTrail = true
    },
    async getLogs () {
      this.loading = true
      // la paginazione si chiama itemsPerPage e non piu' rowsPerPage
      const data = await getLogList(this.filtersLogs, {...this.pagination, rowsPerPage: this.pagination.itemsPerPage})
      data.data = data.data.map(item => {
        item.user = `${item.account.name} ${item.account.surname} (${item.account.role})`
        item.expanded = false
        return item
      })

      this.totalLogs = data.tot
      this.logs = data.data
      this.loading = false
    },
    updateSite (v) {
      this.site = v
      this.getDashboardData()
    },
    updateProtocol (v) {
      this.protocol = v
      this.getDashboardData()
    },
    getDashboardData () {
      getDashboardData(this.protocol, this.site).then(data => {
        this.dashboardData = data
        this.loaded = true
      })
    }
  }
}
</script>

<style lang="scss">
.dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>
